module.exports = __webpack_public_path__ + "static/media/banner-dos.eb92a893.png";